import React from 'react';
import { useNavigate } from 'react-router-dom';
import PaymentBase from './paymentBase';


export const Payment = () => {
  const navigate = useNavigate();
  const goToEditCard = (card) => {
    navigate('./edit-card', { state: { ...card } });
  };

  return (
    <PaymentBase 
      goBack={() => navigate(-1)}
      goAddCard={() => navigate('./add-card')}
      goToEditCard={goToEditCard}
    />
  )
}

export default Payment;
